// Module
var code = "<h1 id=\"用户发行的资产\">用户发行的资产</h1> <p>除了之前提到的 <em>市场锚定资产</em> 外，BitShares允许个人或公司用户创建和发行各种自定义资产凭证(UIA)。相关的应用场景数不胜数。比如，UIA可被用来代替简单的活动门票，存入合格用户的手机钱包中，在进入活动现场时进行实时验证。同样，UIA可被用来进行众筹、所有权追踪，甚至是代表公司的股权。</p> <p>显然，适用于不同凭证使用场景的法律法规可能天差地别，尤其是在不同国家时。所以，BitShares提供了一组工具来帮助发行人来合规发行和管理UIA。</p> ";
// Exports
export default code;